import React from 'react';
import { Link } from 'gatsby';

import Button from '../components/Button';
import { DefaultLogoReel } from '../components/LogoReel';
import USPCardRedesigned from '../components/USPCardRedesigned';
import Playground from '../components/Playground';

const queries = [
  {
    label: 'Simple',
    query: `query {
  shows {
    title
    description
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "The Office",
        "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium."
      },
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends."
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition."
      },
      {
        "title": "The Wire",
        "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement."
      }
    ]
  }
}`,
  },
  {
    label: 'Complex',
    query: `query {
  shows(stage: PUBLISHED) {
    title
    description
    poster {
      url
    }
    episodes {
      title
      actors {
        name
        biography
      }
    }
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "The Office",
        "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium.",
        "poster": {
          "url": "https://media.graphcms.com/WOa8NtHKT3WnIlshxrGT"
        },
        "episodes": [
          {
            "title": "Pilot",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          },
          {
            "title": "Diversity Day",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          },
          {
            "title": "Health Care",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          },
          {
            "title": "The Alliance",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          },
          {
            "title": "Basketball",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          },
          {
            "title": "Hot Girl",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          }
        ]
      },
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends.",
        "poster": {
          "url": "https://media.graphcms.com/xgfwIg0hQeyNAYjOmfsX"
        },
        "episodes": []
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition.",
        "poster": {
          "url": "https://media.graphcms.com/fwItiNHoTba8BUfaNEsu"
        },
        "episodes": [
          {
            "title": "From Pole to Pole",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Mountains",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Fresh Water",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Caves",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Deserts",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Great Plains",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Jungles",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Shallow Seas",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Seasonal Forests",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Ocean Deep",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          }
        ]
      },
      {
        "title": "The Wire",
        "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement.",
        "poster": {
          "url": "https://media.graphcms.com/2HiMRsBQPm9FbqyFG3or"
        },
        "episodes": []
      }
    ]
  }
}`,
  },
  {
    label: 'Filtering',
    query: `query {
  shows(where: {
    title_contains: "Planet"
    episodes_some: {
      length_gt: 30
    }
  }) {
    title
    description 
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition."
      }
    ]
  }
}`,
  },
  {
    label: 'Sorting',
    query: `query {
  shows(orderBy: createdAt_ASC) {
    title
    description 
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "The Office",
        "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium."
      },
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends."
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition."
      },
      {
        "title": "The Wire",
        "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement."
      }
    ]
  }
}`,
  },
  {
    label: 'Pagination',
    query: `query {
  shows(first: 2 skip: 1) {
    title
    description 
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends."
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition."
      }
    ]
  }
}`,
  },
  {
    label: 'Localization',
    query: `query {
  shows(locales: [en, de]) {
    title
    description 
    localizations(includeCurrent: true) {
      description
    }
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "The Office",
        "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium.",
        "localizations": [
          {
            "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium."
          },
          {
            "description": "The Office ist eine amerikanische Mockumentary-Sitcom-Fernsehserie, die den Arbeitsalltag von Büroangestellten in der Filiale der fiktiven Dunder Mifflin Paper Company in Scranton, Pennsylvania, darstellt."
          }
        ]
      },
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends.",
        "localizations": [
          {
            "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends."
          }
        ]
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition.",
        "localizations": [
          {
            "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition."
          },
          {
            "description": "Planet Earth ist eine britische Fernsehserie aus dem Jahr 2006, die von der BBC Natural History Unit produziert wurde. Fünf Jahre später war es die teuerste Naturdokumentationsserie, die jemals von der BBC in Auftrag gegeben wurde, und auch die erste, die in High Definition gedreht wurde."
          }
        ]
      },
      {
        "title": "The Wire",
        "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement.",
        "localizations": [
          {
            "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement."
          }
        ]
      }
    ]
  }
}`,
  },
  {
    label: 'Transforming Assets',
    query: `query {
  shows {
    title
    description
    poster {
      url(transformation: {image: {resize: {width: 200}}})
    }
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "The Office",
        "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium.",
        "poster": {
          "url": "https://media.graphcms.com/resize=width:200/WOa8NtHKT3WnIlshxrGT"
        }
      },
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends.",
        "poster": {
          "url": "https://media.graphcms.com/resize=width:200/xgfwIg0hQeyNAYjOmfsX"
        }
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition.",
        "poster": {
          "url": "https://media.graphcms.com/resize=width:200/fwItiNHoTba8BUfaNEsu"
        }
      },
      {
        "title": "The Wire",
        "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement.",
        "poster": {
          "url": "https://media.graphcms.com/resize=width:200/2HiMRsBQPm9FbqyFG3or"
        }
      }
    ]
  }
}`,
  },
];

const mutations = [
  {
    label: 'Create',
    query: `mutation {
  createActor(data: {
    name: "Steve Carel",
    biography: "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
  }) {
    id
  }
}`,
    response: `{
  "data": {
    "createActor": {
      "id": "cki51mbnk1n0e0b57qbt3oy8w"
    },
  }
}`,
  },
  {
    label: 'Update',
    query: `mutation {
  updateActor(
    where: {
      name: "Steve Carel"
    },
    data: {
      name: "Steve Carell"
    }
  ) {
    id
    name
  }
}`,
    response: `{
  "data": {
    "updateActor": {
      "id": "cki51mbnk1n0e0b57qbt3oy8w",
      "name": "Steve Carell"
    },
  }
}`,
  },
  {
    label: 'Delete',
    query: `mutation {
  deleteActor(
    where: {
      name: "Jenna Fischer"
    }
  ) {
    id
  }
}`,
    response: `{
  "data": {
    "deleteActor": {
      "id": "cki51p5i81mch0a63cqm8nd3r"
    },
  }
}`,
  },
  {
    label: 'Publish',
    query: `mutation {
  publishActor(
    where: {
      name: "David Attenborough"
    },
    to: PUBLISHED
  ) {
    id
  }
}`,
    response: `{
  "data": {
    "publishActor": {
      "id": "cki52b1bc1pby0a01623n2yk7"
    },
  }
}`,
  },
];

const enablingYouToBuildYourBest = [
  {
    image: 'illustrations/localized-content.svg',
    title: 'Localized Content',
    description:
      'Whether you’re handling corporate presence in multiple regions or delivering locale-specific products, our out-of-the-box localization sets you up for success.',
    ctaTo: '/use-cases/content-localization',
  },
  {
    image: 'illustrations/structured-content.svg',
    title: 'Structured Content',
    description:
      'Easily create, iterate on, and enrich your content. Further enhance it through third-party APIs, and unlock programmatic approaches to managing and delivering content.',
    ctaTo: '/use-cases/structured-content',
  },
  {
    image: 'illustrations/content-federation.svg',
    title: 'Content Federation',
    description:
      'Break down your content silos. GraphCMS provides you with central control of your enterprise content from multiple sources through a single, unified content layer.',
    ctaTo: '/use-cases/content-federation',
  },
];

const structureYourContent = [
  {
    icon: 'LIST_CHECK_2',
    title: 'Large set of field types',
    description:
      'All the building blocks you need. Localize or add custom constraints and input validations wherever needed.',
  },
  {
    icon: 'StackLineIcon',
    title: 'Embedded types and components',
    description:
      'Define reusable components for dynamic field sections. Empower content creators to build their own content layouts within their given boundries.',
  },
  {
    icon: 'TerminalLineIcon',
    title: 'Access via UI, API or SDK',
    description:
      'Build and evolve your content model the way it fits best into your workflow. Use the intuitive UI or execute schema changes from code and integrate in your CI/CD processes.',
  },
];

const manageYourContent = [
  {
    icon: 'Layout3LineIcon',
    title: 'Fast and lightweight content studio',
    description:
      'Iterate quickly with an intuitive content management interface for your demanding content creation processes.',
  },
  {
    icon: 'EyeLineIcon',
    title: 'Content preview and staging',
    description:
      'Our customizable content staging allows you to set up safe drafting, preview and publishing processes.',
  },
  {
    icon: 'Attachment2Icon',
    title: 'Digital asset management',
    description:
      'Our inbuilt digital asset management helps you to organize your assets. Add custom metadata and serve assets via a transformation pipeline from a global and fast CDN.',
  },
];

const buildFastApplicationsFaster = [
  {
    icon: 'DeviceLineIcon',
    title: 'Frontend freedom',
    description:
      'With a headless CMS, content is well structured and separated from its presentation. Develop applications for the platform and framework of your choice.',
  },
  {
    icon: 'GRAPHQL',
    title: 'Add value to your product',
    description:
      'Our team of experts is constantly improving and monitoring our enterprise-grade GraphQL engine and infrastructure, so you don’t have to. Focus on adding value to your product.',
  },
  {
    icon: 'TreasureMapLineIcon',
    title: 'Adapt to future trends',
    description:
      'The web and frontend technology ecosystem is evolving rapidly. Adapt to future trends and stacks without being bound to outdated templating languages and frameworks.',
  },
];

const weGenerateYourAPI = [
  {
    icon: 'CODE_FILL',
    title: 'Query and mutation API',
    description:
      'GraphCMS is GraphQL native. Fetch your content with a single API call or ingest data using the mutation API.',
  },
  {
    icon: 'Battery2ChargeLineIcon',
    title: 'Batteries included',
    description:
      'Countless helpers for filtering, sorting, pagination, localization, content staging, publishing or asset transformations included.',
  },
  {
    icon: 'ShieldCheckLineIcon',
    title: 'Powerful permissions',
    description:
      'Granular role based access control for both, your CMS users and API consumers. Express model, field and conditional rules.',
  },
];

const iterateQuickly = [
  {
    icon: 'GitBranchLineIcon',
    title: 'Multiple environments',
    description:
      'Safely iterate on isolated instances of your project without breaking your production systems.',
  },
  {
    icon: 'Medal2FillIcon',
    title: 'Promote environments',
    description:
      'Once your development of a new feature is completed, promote development environments as your new production environments instantly.',
  },
  {
    icon: 'RefreshLineIcon',
    title: 'Integrate with your CI/CD',
    description:
      'Execute all changes programmatically, using the management SDK. Integrate seamlessly into your deployment process.',
  },
];

const ForEngineeringBaseTemplate = ({ pageContext: { page } }) => {
  if (!page) return null;

  const { usps } = page;

  return (
    <React.Fragment>
      <section className="py-6 md:py-12">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row md:items-center md:space-x-6 md:pt-12">
            <div className="w-full md:w-2/5 space-y-6">
              <p className="text-cornflower font-semibold uppercase tracking-wider">
                For Engineering
              </p>
              <h1 className="font-bold leading-tight text-3xl md:text-5xl">
                {page.title}
              </h1>
              <p className="leading-relaxed md:text-lg text-zodiac">
                {page.subTitle}
              </p>
              <Button href="https://app.graphcms.com/signup" colour="purple">
                Sign up for free &#8594;
              </Button>
            </div>

            <div className="w-full md:w-3/5">
              <div className="relative flex items-center justify-center">
                <img
                  src="/illustrations/graphcms-build-on-your-terms.svg"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-6 pt-12 md:pb-6 lg:pt-20">
            {usps.map((usp, index) => (
              <USPCardRedesigned key={index} {...usp} theme="light" />
            ))}
          </div>
        </div>
      </section>

      <section className="bg-whisper py-20">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <DefaultLogoReel />
        </div>
      </section>

      <section className="bg-haiti py-20">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="mx-auto space-y-6 text-center w-full pb-6 md:pb-12">
            <h2 className="text-white font-bold leading-tight text-3xl md:text-5xl">
              Build Your Ultimate Content Pipeline
            </h2>
            <p className="text-whisper">
              Content orchestration pipeline for market-leading digital products
              and services.
            </p>
          </div>

          <div className="hidden md:block max-w-4xl mx-auto">
            <img
              src="/illustrations/full-content-pipeline.svg"
              className="block"
              alt=""
            />
          </div>

          <div className="md:hidden">
            <div className="py-6 space-y-3">
              <img
                src="/illustrations/content-sources.svg"
                className="block mb-12"
                alt=""
              />
              <p className="text-cornflower font-medium uppercase tracking-widest text-sm">
                Sources
              </p>
              <h2 className="text-white font-bold leading-tight text-2xl">
                Create Your Content
              </h2>
              <p className="text-whisper">
                Within minutes, define everything about your content API.
                Structures, localizations, relations, powerful permissions and
                more…
              </p>
            </div>

            <div className="py-6 space-y-3">
              <img
                src="/illustrations/content-destinations.svg"
                className="block mb-12"
                alt=""
              />
              <p className="text-cornflower font-medium uppercase tracking-widest text-sm">
                Destinations
              </p>
              <h2 className="text-white font-bold leading-tight text-2xl">
                Use Your Content
              </h2>
              <p className="text-whisper">
                Within minutes, define everything about your content API.
                Structures, localizations, relations, powerful permissions and
                more…
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="mx-auto space-y-6 text-center w-full max-w-3xl pb-6 md:pb-20">
            <h2 className="text-haiti font-bold leading-tight text-3xl md:text-5xl">
              Enabling You to Build Your Best
            </h2>
            <p className="text-zodiac">
              GraphCMS gives you the ability to manage content with the
              flexibility of a database, and the usability of a CMS - unlocking
              solutions and use-cases that can’t be handled by a generic
              Headless CMS.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
            {enablingYouToBuildYourBest.map(
              ({ image, title, description, cta, ctaTo }, index) => (
                <div
                  key={index}
                  className="space-y-3 md:space-y-6 lg:space-y-12"
                >
                  <div className="h-56 flex items-center justify-center">
                    <img src={image} alt="" />
                  </div>
                  <div className="space-y-3 md:space-y-4 py-3">
                    <h3 className="text-haiti font-bold text-xl">{title}</h3>
                    <p className="text-light-haiti">{description}</p>
                    {ctaTo && (
                      <div>
                        <Link
                          to={ctaTo}
                          className="font-medium group text-cornflower"
                        >
                          {cta || 'Learn more'}
                          <span className="duration-100 group-hover:translate-x-1 inline-block ml-1 transform transition-transform">
                            &#8594;
                          </span>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              )
            )}
          </div>

          <div className="pt-10 md:pt-12 flex justify-center">
            <div className="w-full md:w-1/3 md:px-8">
              <Button href="/use-cases" colour="grey" block>
                See all solutions &#8594;
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-whisper py-20">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="mx-auto space-y-6 text-center w-full max-w-2xl pb-12">
            <h2 className="text-haiti font-bold leading-tight text-3xl md:text-5xl">
              How GraphCMS Works
            </h2>
            <p className="text-zodiac">
              Empower your development and editorial teams' workflows and bring
              your digital projects to life with GraphCMS. Powerful GraphQL API
              for developers, and a seamless editor experience for content
              creators.
            </p>
          </div>

          <div className="w-full md:w-1/2">
            <div className="relative inline-flex items-center pb-4">
              <span className="text-cornflower font-semibold text-sm pr-3">
                01
              </span>
              <span className="h-0.5 w-24 bg-cornflower"></span>
            </div>
            <h3 className="font-bold text-xl md:text-2xl lg:text-3xl leading-snug mb-4 text-haiti">
              Structure Your Content
            </h3>
            <p className="text-zodiac">
              Within minutes, define everything about your content API.
              Structures, localizations, relations, powerful permissions and
              more…
            </p>
          </div>

          <div className="flex flex-col-reverse md:flex-row items-center space-y-6 md:space-y-0 md:space-x-6 md:space-x-12">
            <div className="w-full md:w-1/2">
              <div className="space-y-6 pt-6">
                {structureYourContent.map((usp, index) => (
                  <USPCardRedesigned
                    key={index}
                    {...usp}
                    theme="light"
                    direction="row"
                  />
                ))}
              </div>
            </div>
            <div className="w-full md:w-1/2 h-full md:flex md:items-center md:justify-center">
              <img
                src="/illustrations/structure-your-content.svg"
                className="md:-mt-20"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-haiti py-20">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="mx-auto space-y-6 md:text-center w-full md:w-3/4">
            <div className="relative inline-flex items-center">
              <span className="text-cornflower font-semibold text-sm pr-3">
                02
              </span>
              <span className="h-0.5 w-24 bg-cornflower"></span>
            </div>
            <h2 className="text-white font-bold text-xl md:text-2xl lg:text-3xl leading-snug">
              We Generate Your API
            </h2>
            <p className="text-whisper">
              Use your production-ready GraphQL API to deliver content to any
              platform of your choice.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-6 pt-12 md:pb-6 lg:pt-20 text-whisper">
            {weGenerateYourAPI.map((usp, index) => (
              <USPCardRedesigned key={index} {...usp} theme="purple" />
            ))}
          </div>

          <div className="pt-6 md:pt-12">
            <Playground queries={queries} mutations={mutations} />
          </div>
        </div>
      </section>

      <section className="bg-whisper py-20 md:py-24 space-y-12 md:space-y-24">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="w-full md:w-1/2">
            <div className="relative inline-flex items-center pb-4">
              <span className="text-cornflower font-semibold text-sm pr-3">
                03
              </span>
              <span className="h-0.5 w-24 bg-cornflower"></span>
            </div>
            <h3 className="font-bold text-xl md:text-2xl lg:text-3xl leading-snug mb-4 text-haiti">
              Manage Your Content
            </h3>
            <p className="text-zodiac">
              We give your content creators the tools they're used to - text
              editors, workflows, advanced roles and permissions. All content
              can also be managed programmatically using the mutation API.
            </p>
          </div>

          <div className="flex flex-col-reverse md:flex-row items-center space-y-6 md:space-y-0 md:space-x-6 md:space-x-12 relative">
            <div className="w-full md:w-1/2">
              <div className="space-y-6 py-6">
                {manageYourContent.map((usp, index) => (
                  <USPCardRedesigned
                    key={index}
                    {...usp}
                    theme="light"
                    direction="row"
                  />
                ))}
              </div>
              <Link
                to="/features"
                className="font-medium group text-cornflower"
              >
                Learn more about managing content
                <span className="duration-100 group-hover:translate-x-1 inline-block ml-1 transform transition-transform">
                  &#8594;
                </span>
              </Link>
            </div>
            <div className="w-full md:w-1/2">
              {/* <div className="md:absolute md:top-0 md:-inset-x-1/2 md:-mt-48 md:-mr-72 md:-ml-12 inline-flex flex-col justify-center"> */}
              <div className="relative inline-flex flex-col justify-center">
                <div className="hidden mx-auto border-b border-px border-rock-blue space-x-6">
                  <button
                    className="appearance-none focus:outline-none py-2 font-medium uppercase
                  tracking-wide text-sm -mb-px border-b border-cornflower text-cornflower"
                  >
                    Via Content Studio
                  </button>
                  <button
                    className="appearance-none focus:outline-none py-2 font-medium uppercase
                  tracking-wide text-sm -mb-px border-b border-transparent text-light-haiti hover:text-cornflower"
                  >
                    Via API
                  </button>
                  <button
                    className="appearance-none focus:outline-none py-2 font-medium uppercase
                  tracking-wide text-sm -mb-px border-b border-transparent text-light-haiti hover:text-cornflower"
                  >
                    Via Custom Frontend
                  </button>
                </div>
                <div className="pt-12 md:-mr-84 md:-ml-16">
                  <img
                    src="/illustrations/via-content-studio.svg"
                    className="block md:ml-10 md:-mt-40"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 md:px-6 md:pt-12">
          <div className="md:flex md:justify-end md:pl-12">
            <div className="w-full md:w-1/2">
              <div className="relative inline-flex items-center pb-4">
                <span className="text-cornflower font-semibold text-sm pr-3">
                  04
                </span>
                <span className="h-0.5 w-24 bg-cornflower"></span>
              </div>
              <h3 className="font-bold text-xl md:text-2xl lg:text-3xl leading-snug mb-4 text-haiti">
                Build Fast Applications, Faster
              </h3>
              <p className="text-zodiac">
                Power all your applications and websites with unified content.
                Served from a single, secured endpoint.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-12">
            <div className="w-full md:w-1/2 h-full md:flex md:items-center md:justify-center">
              <img
                src="/illustrations/build-fast-applications-faster.svg"
                className="md:-mt-24"
                alt=""
              />
            </div>
            <div className="w-full md:w-1/2">
              <div className="space-y-6 py-6">
                {buildFastApplicationsFaster.map((usp, index) => (
                  <USPCardRedesigned
                    key={index}
                    {...usp}
                    theme="light"
                    direction="row"
                  />
                ))}
              </div>
              <Link
                to="/blog/graphcms-quickstart"
                className="font-medium group text-cornflower"
              >
                Get to speed with our quickstart guide
                <span className="duration-100 group-hover:translate-x-1 inline-block ml-1 transform transition-transform">
                  &#8594;
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-whisper pb-12 md:pb-20">
        <div className="max-w-6xl mx-auto px-4 md:px-6 md:space-y-12">
          <div className="mx-auto space-y-6 md:text-center w-full md:w-3/4">
            <div className="relative inline-flex items-center">
              <span className="text-cornflower font-semibold text-sm pr-3">
                05
              </span>
              <span className="h-0.5 w-24 bg-cornflower"></span>
            </div>
            <h2 className="text-haiti font-bold text-xl md:text-2xl lg:text-3xl leading-snug">
              Iterate Quickly
            </h2>
            <p className="text-zodiac">
              Don’t be afraid to iterate quickly. GraphCMS gives you all the
              tools for maintaining your development velocity.
            </p>
          </div>

          <div className="flex flex-col-reverse md:flex-col space-y-12">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-6 pt-6 md:pb-6">
              {iterateQuickly.map((usp, index) => (
                <USPCardRedesigned key={index} {...usp} theme="light" />
              ))}
            </div>

            <div className="max-w-4xl mx-auto">
              <img
                src="/illustrations/iterate-quickly.svg"
                className="block"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white relative">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-6">
          <div className="md:flex md:space-x-12 items-stretch">
            <div className="w-full md:w-2/5 pt-8 pb-4 md:py-32">
              <div className="space-y-6">
                <h2 className="text-haiti font-bold text-3xl lg:text-4xl leading-snug">
                  Integrate with Your Favorite Tools
                </h2>
                <p className="text-zodiac text-lg">
                  GraphCMS has a growing set of integrations to make the best
                  use of the developer ecosystem.
                </p>
                <Button href="https://app.graphcms.com/signup" colour="purple">
                  Sign up for free &#8594;
                </Button>
              </div>
            </div>
            <div className="w-full md:w-3/5 relative py-4">
              <img
                src="/illustrations/tools.svg"
                alt="Logos of industry tools and software"
              />
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default ForEngineeringBaseTemplate;
